import styled from "@emotion/styled";
import { color } from "metabase/lib/colors";

export const PanelRoot = styled.div`
  margin: 0 1.5rem;
`;

export const PanelToolbar = styled.div`
  margin-bottom: 1rem;
`;
